module.exports = __webpack_public_path__ + "static/media/slide4.f4ff8603.jpg";